import NftMetadata from "../interfaces/NftMetadata";
import { DRAGOS_PREFIXES, DRAGO_GENS } from "../vars";

export default (drago: NftMetadata) => {
    for (let prefix of DRAGOS_PREFIXES) {
        if (drago.name.includes(prefix)) {
            return Object.keys(DRAGO_GENS).includes(prefix) ? DRAGO_GENS[prefix as keyof typeof DRAGO_GENS] : 0
        }
    }
}